module.exports = __webpack_public_path__ + "img/ResumeTemp3.038669cb.png";